const BaseView = require('../components/common/common-component');
const MlsView = require('./mls');
const template = require('./mls-template.hbs');

module.exports = BaseView.extend({
  type: 'mls',

  isAlreadyThere: function () {
    return !!this.$el.find('.tab-content.mls').length;
  },

  render: async function () {
    await BaseView.prototype.render.call(this);
    this.$headerLinks.filter('[data-key=mls]').trigger('click');
    this.$el.find('.search-container').find('input').attr('placeholder', 'Search Listings');
  },

  refresh: function () {
    BaseView.prototype.refresh.call(this);
    this.$el.find('.search-container').removeClass('disabled');
    const activeImagesTab = this.$el.find('.header').find('.active[data-key=images]');

    activeImagesTab.length && activeImagesTab.removeClass('active').trigger('click');
  },

  initMlsView: function () {
    this.registerTabView('mls', new MlsView({el: this.initTabView('mls')}));
  },

  initTabView: function (type) {
    const $view = this.$el.find('.tab-content > .' + type);
    $view.html(template({
      type: type,
      isMls: type === 'mls'
    }));

    return $view;
  }
});
